// Central index for all chapter modules
// Each chapter is its own file for easy editing

import chapter1 from './chapter1';
import chapter2 from './chapter2';
import chapter3 from './chapter3';
import chapter4 from './chapter4';
import chapter5 from './chapter5';
import chapter6 from './chapter6';
import chapter7 from './chapter7';

// Transform chapter quiz data to expected format for App.js
// Converts quizQuestions array to quiz object with proper field names
const transformChapter = (chapter) => {
  return {
    ...chapter,
    quiz: chapter.quizQuestions && chapter.quizQuestions.length > 0 ? {
      title: `Chapter ${chapter.id} Quiz: ${chapter.title}`,
      questions: chapter.quizQuestions.map(q => ({
        question: q.question,
        options: q.options,
        correctAnswer: q.correct,
        explanation: q.explanation
      }))
    } : null
  };
};

export const courseContent = {
  title: "SD Crop Insurance",
  subtitle: "Pre-Licensing Course",
  estimatedHours: "20+",
  passingScore: 70,
  chapters: [
    transformChapter(chapter1),
    transformChapter(chapter2),
    transformChapter(chapter3),
    transformChapter(chapter4),
    transformChapter(chapter5),
    transformChapter(chapter6),
    transformChapter(chapter7)
  ]
};

export default courseContent;
